<template>
  <div>
    <!-- Modal Component - impressão de documentos -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Impressão de documentos')"
      ref="modalPrintAll"
      @ok="handleOkPrint"
      :okDisabled="isValidEmail() ? false : true"
    >
      <b-form>
        <p>
          {{
    $t(
              "Suas nostas fiscais e GNREs serão exportadas para um arquivo PDF e este arquivo será enviado para você assim que este processo estiver concluído."
    )
}}
        </p>
        <hr />
      </b-form>
    </b-modal>

    <!-- Modal Component - exportação de pedidos -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos')"
      ref="modalExportOrders"
      @ok="handleOk"
    >
      <b-form>
        <p>
          {{
    $t(
              "Todos os seus pedidos serão exportados para um arquivo no formato escolhido e este arquivo será enviado para você assim que este processo estiver concluído."
    )
}}
        </p>

        <hr />

        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected1"
            name="customRadioSelected"
            class="custom-control-input"
            checked
            v-model="exportSelected"
            value="csv"
          />
          <label class="custom-control-label" for="customRadioSelected1">{{
    $t("Exportar como XLSX")
}}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected2"
            name="customRadioSelected"
            class="custom-control-input"
            v-model="exportSelected"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadioSelected2">{{
    $t("Exportar como PDF")
}}</label>
        </div>

        <div v-if="exportSelected === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox1"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox1"
              >Versão compacta</label
            >
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- modalExportFilterOrders -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos filtrados')"
      ref="modalExportFilterOrders"
      @ok="handleOkFilterEndEmail"
    >
      <b-form>
        <p>
          {{
    $t(
              "Todos os seus pedidos serão exportados para um arquivo no formato escolhido e este arquivo será enviado para você assim que este processo estiver concluído."
    )
}}
        </p>

        <hr />

        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected1"
            name="customRadioSelected"
            class="custom-control-input"
            checked
            v-model="exportSelected"
            value="csv"
          />
          <label class="custom-control-label" for="customRadioSelected1">{{
    $t("Exportar como XLSX")
}}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected2"
            name="customRadioSelected"
            class="custom-control-input"
            v-model="exportSelected"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadioSelected2">{{
    $t("Exportar como PDF")
}}</label>
        </div>

        <div v-if="exportSelected === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox1"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox1"
              >Versão compacta</label
            >
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- modalExportOrderSelectedEmail -->
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos selecionados')"
      ref="modalExportOrderSelectedEmail"
      @ok="handleOkSelectedEndEmail"
    >
      <b-form>
        <p>
          {{
    $t(
              "Todos os seus pedidos serão exportados para um arquivo no formato escolhido e este arquivo será enviado para você assim que este processo estiver concluído."
    )
}}
        </p>

        <hr />

        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected1"
            name="customRadioSelected"
            class="custom-control-input"
            checked
            v-model="exportSelected"
            value="csv"
          />
          <label class="custom-control-label" for="customRadioSelected1">{{
    $t("Exportar como XLSX")
}}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadioSelected2"
            name="customRadioSelected"
            class="custom-control-input"
            v-model="exportSelected"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadioSelected2">{{
    $t("Exportar como PDF")
}}</label>
        </div>

        <div v-if="exportSelected === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox1"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox1"
              >Versão compacta</label
            >
          </div>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('Exportação de pedidos')"
      ref="modalExportOrdersSelected"
      @ok="exportSelecionados"
    >
      <b-form>
        <p>{{ $t("Qual formato deseja exportar os pedidos selecionados?") }}</p>
        <hr />
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadio1"
            name="customRadio"
            class="custom-control-input"
            checked
            v-model="exportSelected2"
            value="csv"
          />
          <label class="custom-control-label" for="customRadio1">{{
    $t("Exportar como XLSX")
}}</label>
        </div>
        <div class="custom-control custom-radio">
          <input
            type="radio"
            id="customRadio2"
            name="customRadio"
            class="custom-control-input"
            v-model="exportSelected2"
            value="pdf"
          />
          <label class="custom-control-label" for="customRadio2">
            {{ $t("Exportar como PDF") }}
          </label>
        </div>

        <div v-if="exportSelected2 === 'pdf'">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              name="compactPdfCheckbox"
              id="compactPdfCheckbox"
              v-model="compactPdf"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label" for="compactPdfCheckbox">
              Versão compacta
            </label>
          </div>
        </div>
      </b-form>
    </b-modal>
    <AlerSpinner :expedition="expedition" />
  </div>
</template>

<script>
import DanfeA4Simplified from "../../../util/danfeA4Simplified";
import AlerSpinner from "./ActionMenuDropdown/AlerSpinner.vue";
import { mapGetters, mapActions } from "vuex";
import barramento from "../../../barramento";
import swal from "sweetalert2";
import axios from "axios";
import _ from "lodash";

export default {
  props: [
    "items",
    "value",
    "loadTotalOrders",
    "filters",
    "filtro",
    "user",
    "listen_bus",
    "expedition",
  ],
  inject: ['getSelectedOrderIds', 'clearSelectedOrders'],
  beforeDestroy() {
    barramento.$off(this.listen_bus);
  },
  created() {
    barramento.$on(this.listen_bus, (action) => {
      this.action = action;
      // Busca os IDs selecionados diretamente do DOM no momento do clique
      this.idsOnActionList = this.getSelectedOrderIds();
      this.performAction();
    });
  },
  components: { AlerSpinner },
  data() {
    return {
      action: null,
      exportSelected: "csv",
      exportSelected2: "csv",
      email: null,
      file: null,
      type: "all",
      fileName: "Selecione",
      compactPdf: false,
      idsOnActionList: [],
      only_filtered: false,
      plp_attempts: 0,
    };
  },
  computed: {
    hasPermissionToExport() {
      const subuser = this.user.pluggToSubuser;
      const permissions = subuser ? subuser.permissions : null;
      const has = !(
        subuser &&
        permissions &&
        !permissions.find((x) => x === "core.exportOrders")
      );
      return has;
    },
  },

  methods: {
    ...mapActions({
      cleanActionList: "cleanActionList",
    }),

    exportErrorAlert() {
      swal({
        title: "Ops!",
        text: this.$t("Você não possui permissão para exportar pedidos."),
        type: "error",
        closeOnConfirm: false,
        closeOnCancel: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
    },

    setFile() {
      if (
        this.$refs &&
        this.$refs.file &&
        this.$refs.file.files &&
        this.$refs.file.files[0]
      ) {
        this.file = this.$refs.file.files[0];
        this.fileName = `${this.file.name.substr(0, 7)}...`;
      }
    },
    optionStatusEntregue() {
      barramento.$emit("orders_action_status", this.action === "delivered");
    },
    performAction() {
      var self = this;

      switch (this.action) {
        case "action_processing_picking":
          if (!this.idsOnActionList.length) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              ),
            });
            return false;
          }
          this.changeStatus("picking", "processing_picking", true);
          break;
        case "action_pending_invoice":
          this.changeStatus("picking", "pending_invoice", true);
          break;
        case "action_waiting_invoice":
          this.changeStatus("waiting_invoice", "waiting_invoice", true);
          break;
        case "action_print_all":
          this.type == "all";
          this.showPrintAllModal();
          break;

        case "action_print_notas_fiscais_all":
          this.type == "all";
          this.print_danfe_all();
          break;

        case "action_print_filter":
          if (!this.filtro) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum filtro executado. Por favor, realize um filtro para exportar os pedidos filtrados."
              ),
            });
            return false;
          }

          swal({
              title: "Quais etiquetas exportar?",
              type: "warning",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: 'Todas as filtradas',
              cancelButtonText: "Filtradas não impressas",
              text: this.$t(
                "Até 1000 etiquetas vamos gerar um único arquivo pdf, acima disso você receberá um zip com 1000 etiquetas em cada arquivo."
              ),
            }).then((isConfirm) => {
              if(isConfirm.value)
              {
                this.print_labels_by_filters();
              }else{
                this.print_labels_by_filters(true);
              }
            });

          break;
        case "action_print_nfe":
          this.print_nfes();
          break;
        case "action_print_xlsx_nfe":
          this.print_xlsx_nfes();
          break;
        case "action_print_gnre":
          this.print_gnres();
          break;
        case "action_print_labels":
          this.print_labels();
          break;
        case "action_create_plp":
          this.plp_attempts = 0;
          this.create_plp();
          break;
        case "action_processing_expedition":
          this.changeStatus("invoiced", "processing_expedition", true);
          break;
        case "action_dispatched":
          this.changeStatus("shipping_informed", "dispatched", true);
          break;
        case "exportAllOrders":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          this.showExportOrderModal();
          break;
        case "exportAllOrdersFiltered":
          if (!this.filtro) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum filtro executado. Por favor, realize um filtro para exportar os pedidos filtrados."
              ),
            });
            return false;
          }
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          this.showExportOrderFilterModal();
          break;
        case "exportAllOrdersSelected":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          if (!this.idsOnActionList.length) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido para exportar"
              ),
            });
            return false;
          }
          if (this.idsOnActionList.length > 100) this.showExportOrderSelectedEmailModal();
          else this.showExportOrderSelectedModal();
          break;
        case "action_print_header_pdf":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          if (!this.idsOnActionList.length) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido realizar esta ação"
              ),
            });
            return false;
          }
          this.createHeaderPDF();
          break;
        case "exportModel":
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          this.exportModel();
          break;
        case "exportModelFiltered":
          if (!this.filtro) {
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Nenhum filtro aplicado. Por favor, realize um filtro para exportar planilha de entrega com pedidos filtrados."
              ),
            });
            return false;
          }
          if (!this.hasPermissionToExport) {
            this.exportErrorAlert();
            return;
          }
          this.exportModelFiltered();
          break;
        case "delivered":
          this.changeStatus("delivered", null, true);
          break;
        case "picking":
          this.changeStatus("picking", "pending_invoice", true);
          break;
        case "canceled":
          swal({
            title: this.$t("Você tem certeza?"),
            type: "warning",
            text: this.$t("Realmente deseja cancelar os pedidos?"),
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: true,
            cancelButtonText: "Não",
            confirmButtonText: "Sim, Cancelar pedido!",
          }).then((ok) => {
            if (ok.value === true) {
              this.changeStatus("canceled", null, true);
            }
          });
          break;
        case "action_sigep":
          this.sigep(true);
          break;
        case "resendnotifications":
          this.resendNotifications();
          break;
        case "action_generate_labels":
          if (!this.idsOnActionList.length) {
            swal({
              title: "Ops!",
              text: this.$t(
                "Nenhum pedido selecionado. Por favor, selecione ao menos um pedido para realizar esta ação."
              ),
              type: "warning",
            });
            return false;
          }

          var oders_id = []; // FILTRAR O QUE NÃO É Fulfillment
          for (var i in this.items) {
            if (
              this.items[i].delivery_type !== "fulfillment" &&
              this.idsOnActionList.find((fruit) => fruit === this.items[i].id)
            ) {
              oders_id.push(this.items[i].id);
            }
          }

          if (!oders_id.length) {
            swal({
              title: "Ops!",
              text: this.$t(
                "Todos pedidos selecionados são Fulfillment, etiquetas não disponibilizadas."
              ),
              type: "warning",
            });
            return false;
          }

          this.generate_labels(oders_id);
          break;
      }
    },
    print_nfes() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;
      this.type == "nfe";
      if (sel_itens <= 20) {
        for (i = 0; i < sel_itens; i++) {
          q = _.find(this.items, { id: this.idsOnActionList[i] });

          if (q) {
            ids.push({
              id: this.idsOnActionList[i],
              shipments: q.shipments,
            });
          }
        }
        axios
          .post("/api/documents/get_nfes", ids)
          .then((response) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            if (response.data.erro) {
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
                ),
                type: "error",
              });
            } else {
              let link = document.createElement("a");
              link.setAttribute("href", response.data.file);
              link.setAttribute("download", response.data.file);
              link.setAttribute("target", "_blank");
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Notas fiscais geradas com sucesso!"),
                type: "success",
              });
            }
          })
          .catch((error) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            swal({
              title: "Ops!",
              text: this.$t(response.data.erro),
              type: "error",
            });
          });
      } else {
        barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
        swal({
          title: this.$t("Ops!"),
          text: this.$t(
            "Você selecionou " + sel_itens + " pedidos. Por favor, selecione até 20."
          ),
          type: "error",
        });
      }
    },
    print_xlsx_nfes() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;
      this.type == "nfe";
      for (i = 0; i < sel_itens; i++) {
        q = _.find(this.items, { id: this.idsOnActionList[i] });
        if (q) {
          ids.push({
            id: this.idsOnActionList[i],
            shipments: q.shipments,
          });
        }
      }

      axios
        .post("/api/orders/export/nf", ids)
        .then((response) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          if (response.data.erro) {
            swal({
              title: "Ops!",
              text: this.$t(
                "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
              ),
              type: "error",
            });
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            swal({
              title: this.$t("Pronto!"),
              text: this.$t("Notas fiscais geradas com sucesso!"),
              type: "success",
            });
          }
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            text: this.$t(response.data.erro),
            type: "error",
          });
        });
    },
    print_gnres() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      var ids = [];
      var i;
      var sel_itens = this.idsOnActionList.length;
      var q;
      this.type == "nfe";

      if (sel_itens > 0) {
        if (sel_itens == this.items.length) {
          this.showPrintAllModal();
        } else {
          for (i = 0; i < sel_itens; i++) {
            q = _.find(this.items, { id: this.idsOnActionList[i] });

            if (q) {
              ids.push({
                id: this.idsOnActionList[i],
                shipments: q.shipments,
              });
            }
          }

          axios
            .post("/api/documents/get_gnres", ids)
            .then((response) => {
              barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
              if (response.data.erro) {
                swal({
                  title: "Ops!",
                  text: this.$t(response.data.erro),
                  type: "error",
                });
              } else {
                let link = document.createElement("a");
                link.setAttribute("href", response.data.file);
                link.setAttribute("download", response.data.file);
                link.setAttribute("target", "_blank");
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                swal({
                  title: this.$t("Pronto!"),
                  text: this.$t("GNREs geradas com sucesso!"),
                  type: "success",
                });
              }
            })
            .catch((error) => {
              barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
                ),
                type: "error",
              });
            });
        }
      } else {
        this.showPrintAllModal();
      }
    },
    generate_labels(orders_ids, endpoint = "/api/documents/make_label") {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      barramento.$emit(`alert_spinner_${this.expedition}`, true);
      axios({
        method: "POST",
        url: endpoint,
        data: orders_ids,
        headers: { "content-type": "application/json" },
      }).then(
        (response) => {
          var urls = response.data.urls;
          for (var i in urls) {
            var pdf_link = urls[i];
            if (!!pdf_link) {
              var type = pdf_link.substr(pdf_link.length - 3);
              let link = document.createElement("a");
              link.setAttribute("href", pdf_link);
              link.setAttribute("target", "_blank");
              if (type == "zpl") {
                link.setAttribute("download", "etiqueta.zpl");
                link.href = window.URL.createObjectURL(new Blob([pdf_link], { type }));
              } else {
                link.setAttribute("download", pdf_link);
              }
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(link.href);
              document.body.removeChild(link);
            }
          }
          barramento.$emit(`alert_spinner_${this.expedition}`, false);
          barramento.$emit(`loading_filters_${this.expedition}`, false);
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
        },
        (error) => {
          barramento.$emit(`alert_spinner_${this.expedition}`, false);
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          let message = "Etiqueta não está disponivel";
          if (
            error.response &&
            (typeof error.response.data === "string" ||
              error.response.data instanceof String)
          ) {
            message = error.response.data;
          }
          swal({
            title: "Ops!",
            html: message,
            type: "warning",
          });
        }
      );
    },
    print_labels_by_filters(label_printed = false) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      let filters = JSON.parse(JSON.stringify(this.filtro));

      let data = {
        ...filters,
      };

      if(label_printed)
      {
        data.label_printed = true
      }

      const sendRequest = () => {
        return axios
          .post('api/orders/export_labels', data)
          .then((response) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            swal({
              title: "Pronto!",
              text: response.data,
              type: "success",
            });
          })
          .catch((error) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            swal({
              title: "Ops!",
              text: "Erro ao enviar etiquetas para impressão",
              type: "error",
            });
          });
      };

      sendRequest();
    },

    print_labels() {
      var order = [];
      if (this.idsOnActionList.length > 0) {
        for (var i in this.items) {
          if (this.idsOnActionList.includes(this.items[i].id)) order.push(this.items[i]);
        }
      } else order = this.items;

      DanfeA4Simplified.forEtiqueta(order, this.expedition);
    },
    create_plp() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      let obj = [];
      for (var i in this.items) {
        var plp = null;
        if (this.idsOnActionList.includes(this.items[i].id)) {
          if (this.items[i].shipments.length) {
            plp = this.items[i].shipments[0].label_info.plp;
          }
          obj.push({
            id: this.items[i].id,
            plp: plp,
          });
        }
      }

      if (!obj.length) {
        swal({
          title: "Ops!",
          type: "warning",
          text: this.$t(
            "Nenhum pedido selecionado. Por favor, selecione ao meno um pedido."
          ),
        });
        return false;
      }

      var finalizado = false;

      axios
        .post("/api/documents/create_plp", { pluggto_order_ids: obj })
        .then((response) => {
          finalizado = true;
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          barramento.$emit(`expedition_loding_${this.expedition}`);
          barramento.$emit(`loading_filters_${this.expedition}`, {});
          this.downloadFile(response.data.url, `plp_${response.data.sigep_plp_id}.pdf`);
        })
        .catch((error) => {
          this.plp_attempts++;

          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);

          // --- VOU CRIAR 3 tentativas;
          if (this.plp_attempts <= 3) return this.create_plp();
          else finalizado = true;

          swal({
            title: "Ops!",
            text: this.$t(error.response.data),
            type: "error",
          });
        })
        .finally(() => {
          if (finalizado) {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            barramento.$emit(`loading_filters_${this.expedition}`, {});
          }
        });
      return;
    },
    createHeaderPDF() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      var tz = new Date().getTimezoneOffset();
      let data = {
        filtered: false,
        type: "pdfHeader",
        tzUTC: tz,
        ids: [],
      };

      data.ids = this.idsOnActionList.length > 0 ? this.idsOnActionList : [];

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Cabeçalho dos Pedidos exportados com sucesso!"),
            type: "success",
          });
          return;
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          if (error) {
            swal({
              title: "Ops!",
              text: this.$t(
                "É necessário que tenha o XML para poder imprimir os cabeçalhos."
              ),
            });
          }
          return;
        });
    },
    downloadFile(url, fileName) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      const a = document.createElement("a");
      a.style.display = "none";
      document.body.appendChild(a);

      a.href = url;

      a.setAttribute("download", fileName);

      a.setAttribute("target", "_BLANK");

      a.click();

      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
    },

    showExportOrderModal() {
      this.$refs.modalExportOrders.show();
    },

    showExportOrderFilterModal() {
      this.$refs.modalExportFilterOrders.show();
    },

    showExportOrderSelectedEmailModal() {
      this.$refs.modalExportOrderSelectedEmail.show();
    },

    showExportOrderSelectedModal() {
      this.$refs.modalExportOrdersSelected.show();
    },

    showPrintAllModal() {
      this.$refs.modalPrintAll.show();
    },

    exportSelecionados(event) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      var tz = new Date().getTimezoneOffset();
      let data = {
        filtered: false,
        type: this.exportSelected2,
        tzUTC: tz,
        ids: [],
      };

      if (this.exportSelected2 === "pdf") {
        data.compactPdf = this.compactPdf;
      }

      data.ids = this.idsOnActionList;

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);*/
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"),
            type: "success",
          });
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          if (error) {
            swal({
              title: "Ops!",
              text: this.$t("Erro ao tentar exportar pedidos."),
            });
          }
        });
    },

    exportModelFiltered() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      let data = {
        filters: this.filtro,
        email: this.email,
        type: 'delivery',
        ids: this.idsOnActionList,
      };
      axios
        .post("/api/orders/export", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar planilha de entrega dos pedidos."),
            type: "error",
          });
      });
    },

    exportModel() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      var order = [];
      for (var i in this.items) {
        if (this.idsOnActionList.includes(this.items[i].id)) {
          order.push(this.items[i].before);
        }
      }

      axios
        .post("/api/orders/export/shippingSheet", {
          orders: order,
        })
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            text: this.$t(
              "É necessário que tenha o XML para poder imprimir os cabeçalhos."
            ),
          });
        });
    },
    concatFilter(filter, key) {
      if (!!filter) return filter[key];
      return null;
    },
    handleOk(event) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      let data = {
        filters: this.filters,
        email: this.email,
        type: this.exportSelected,
        ids: [],
      };

      if(this.expedition == 'integracao_incorreta') {
        data.filters.integrated = 0;
        data.filters.ack = false;
      }

      if (this.exportSelected === "pdf") data.compactPdf = this.compactPdf;

      axios
        .post("/api/orders/export", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
          this.$refs.modalExportOrders.hide();
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          this.$refs.modalExportOrders.hide();
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os pedidos."),
            type: "error",
          });
        });
    },
    handleOkFilterEndEmail() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      let data = {
        filters: this.filtro,
        email: this.email,
        type: this.exportSelected,
        ids: [],
      };

      if(this.expedition == 'integracao_incorreta') {
        data.filters.integrated = 0;
        data.filters.ack = false;
      }

      if (this.exportSelected === "pdf") data.compactPdf = this.compactPdf;

      axios
        .post("/api/orders/export", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
          this.$refs.modalExportOrders.hide();
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          this.$refs.modalExportOrders.hide();
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os pedidos."),
            type: "error",
          });
        });
    },
    handleOkSelectedEndEmail() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      let data = {
        filters: this.filters,
        email: this.email,
        type: this.exportSelected,
        ids: this.idsOnActionList,
      };

      if (this.exportSelected === "pdf") data.compactPdf = this.compactPdf;

      axios
        .post("/api/orders/export", data)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
          this.$refs.modalExportOrders.hide();
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          this.$refs.modalExportOrders.hide();
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os pedidos."),
            type: "error",
          });
        });
    },
    print_danfe_all() {
      var itemsArray = [];

      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);

      for (var i = 0; i < this.idsOnActionList.length; i++) {
        for (var j = 0; j < this.items.length; j++) {
          if (this.items[j].id === this.idsOnActionList[i]) {
            itemsArray.push(this.items[j]);
          }
        }
      }

      DanfeA4Simplified.printDanfA4Simplificada(itemsArray, true, this.expedition);
    },

    handleOkPrint(event) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      event.preventDefault();

      let data = {
        email: this.email,
        type: this.type,
      };
      this.$refs["modalExportOrders"].hide();
      axios
        .post("/api/documents/get_all", data)
        .then((success) => {
          this.email = null;
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Agendamento de exportação de documentos criado com sucesso, acompanhe o seu e-mail!"
            ),
            type: "success",
          });
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            text: this.$t("Não foi possivel exportar os documentos."),
            type: "error",
          });
        });

      this.type == "all";
      this.$refs.modalExportOrders.hide();
    },

    importOrders(event) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      event.preventDefault();
      let btn = event.target.querySelector(".fa");
      btn.classList.toggle("fa-play");
      btn.classList.toggle("fa-spinner");

      let formData = new FormData();
      formData.append("sheet", this.file);

      axios
        .post("/api/orders/import", formData)
        .then((success) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t(
              "Seu arquivo já foi incluido para importação, em breve você podera vê-lo em seu painel."
            ),
            type: "success",
          });
          btn.classList.toggle("fa-play");
          btn.classList.toggle("fa-spinner");
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel processar seu arquivo, tente novamente em alguns instantes."
            ),
            type: "error",
          });
          btn.classList.toggle("fa-play");
          btn.classList.toggle("fa-spinner");
        });
    },

    changeStatus(status, sub_status, show_modal) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      if (!this.idsOnActionList.length) {
        swal({
          title: "Ops!",
          type: "warning",
          text: this.$t("Você selecionou os pedidos para aplicar esta ação?"),
        });
        barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
      } else {
        // Captura imediata dos IDs para evitar qualquer modificação durante o processamento
        const idsToProcess = [...this.idsOnActionList];

        let ids = idsToProcess.map((id) => {
          return { id: id, status: status, sub_status: sub_status };
        });

        this.$http
          .post("/api/orders/updatestatus", ids)
          .then((response) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            let ids = response.data.join(", ");
            if (response.data.length) {
              swal({
                title: "Ops!",
                type: "warning",
                text: this.$t(
                  "Não foi possivel alterar o status dos pedidos com ID: ${ids}, tente novamente em alguns instantes."
                ),
              });
              return;
            }
            if (show_modal == true) {
              barramento.$emit("loading_filters", true);
              swal({
                title: "Pronto!",
                type: "success",
                text: this.$t("Os status dos pedidos foram alterados com sucesso!"),
              });
            }

            // Limpa seleção manipulando DOM diretamente
            this.clearSelectedOrders();

            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            barramento.$emit(`loading_filters_${this.expedition}`);
          })
          .catch((error) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            swal({
              title: "Ops!",
              type: "warning",
              text: this.$t(
                "Não foi possivel alterar o status dos pedidos com ID: ${ids}, tente novamente em alguns instantes."
              ),
            });
          });
        if (status == "picking" && sub_status == "processing_picking") {
          this.exportPicking();
        }
      }
    },

    exportPicking() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      let data = {
        filtered: false,
        type: this.exportSelected2,
        ids: [],
      };

      data.ids = this.idsOnActionList;

      axios
        .post("/api/orders/export/picking", data)
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Lista de picking gerada com sucesso!"),
            type: "success",
          });
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal({
            title: "Ops!",
            type: "warning",
            text: this.$t(
              "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes."
            ),
          });
        });
    },

    sigep(show_modal) {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      if (!this.idsOnActionList.length) {
        swal({
          title: "Ops!",
          type: "warning",
          text: this.$t("Você selecionou os pedidos para aplicar esta ação?"),
        });
      } else {
        let ids = this.idsOnActionList.map((id) => {
          return { id: id };
        });

        this.$http
          .post("/api/orders/sigep", ids)
          .then((response) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
            let ids = response.data.join(", ");
            if (response.data.length) {
              swal({
                title: "Ops!",
                type: "warning",
                text: this.$t(
                  "Não foi possivel alterar o método de envio, tente novamente em alguns instantes."
                ),
              });
              return;
            }
            if (show_modal == true) {
              swal({
                title: "Pronto!",
                type: "success",
                text: this.$t("Os pedidos foram alterados com sucesso!"),
              });
            }
          })
          .catch((error) => {
            barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          });
      }
    },

    resendNotifications() {
      barramento.$emit(`orders_load_nav_bar_${this.expedition}`, true);
      if (!this.idsOnActionList.length) {
        swal({
          title: "Ops!",
          type: "warning",
          text: this.$t("Você selecionou os pedidos para aplicar esta ação?"),
        });
        barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
        return;
      }

      this.$http
        .post("/api/orders/notification/resend", this.idsOnActionList)
        .then((response) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          if (response.data) {
            let ids = response.data;
            if (ids.length != 0) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel reenviar as notificações dos pedidos selecionados, tente novamente em alguns instantes."
                ),
                "warning"
              );

              let messageArr = ids.map((oneError) => {
                let msgError = oneError.error.toLowerCase()
                msgError = msgError.includes('payment_type') ? this.$t('msg.voucher.error') : msgError;
                return `${oneError.id}: ${msgError}`
              });

              let finalMessage = '<ul><li>';
              finalMessage += messageArr.join('</li><li>');
              finalMessage += '</li></ul>';

              swal({
                title: "Ops",
                html: `Ocorreu os seguintes erros nos pedidos:<br>,${finalMessage}`
              });

              return;

            }

            swal(
              this.$t("Pronto!"),
              this.$t("O reenvio da notificação foi enviado com sucesso!"),
              "success"
            );
          }
        })
        .catch((error) => {
          barramento.$emit(`orders_load_nav_bar_${this.expedition}`, false);
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel reenviar a notificação para os pedidos selecionados, tente novamente em alguns instantes."
            ),
            "warning"
          );
        });

      this.cleanActionList();
    },

    isValidEmail() {
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(String(this.email).toLowerCase());
    },

    toggleLoadingButton(btn = null) {
      // let btn = this.$refs.submitButton;
      let icon = btn.querySelector("i");
      icon.classList.toggle("fa-play");
      icon.classList.toggle("fa-spinner");

      if (icon.classList.contains("fa-spinner")) {
        btn.setAttribute("disabled", true);
      } else {
        btn.removeAttribute("disabled");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Action.vue